'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './mail-recipient-edit.routes';

export class MailRecipientEditComponent {

  constructor(Auth, RecipientListService, $stateParams, dialogs, $state) {
    'ngInject';

    this.RecipientListService = RecipientListService;
    this.dialogs = dialogs;
    this.$state = $state;
    this.recipientListId = $stateParams.id;

    this.recipientListTemplate = {
      name: '',
      description: '',
      data: [],
      meta: {
        creationUser: Auth.getCurrentUserSync()._id,
        active: true
      }
    };

    this.recipientList = angular.copy(this.recipientListTemplate);

    if (this.recipientListId) {
      this.RecipientListService.get({id: this.recipientListId}, data => {
        this.recipientList = data;
        this.recipients = data.recipients === null ? '' : data.recipients.join("\n");
      }, err => {
        console.log('Could not load recipient list from server');
      })
    }
/*
    CodeMirror.defineOption("matchBrackets", true);
    CodeMirror.defineOption("autoCloseBrackets", true);
    CodeMirror.defineOption("lineWrapping", true);
    CodeMirror.defineOption("tabSize", 2);
    CodeMirror.defineOption("mode", "application/json");
    CodeMirror.defineOption("gutters", ["CodeMirror-lint-markers"]);
    CodeMirror.defineOption("lint", true);*/

    CodeMirror.defineOption("mode", "text/plain");
    CodeMirror.defineOption("styleActiveLine", true);
    CodeMirror.defineOption("lineNumbers", true);
  }

  sortList(order) {
    var sorted = this.recipients.split(/\n/).sort(function (a, b) {
      if (order == 'asc') {
        return a.toLowerCase().localeCompare(b.toLowerCase());
      } else {
        return b.toLowerCase().localeCompare(a.toLowerCase());
      }
    });
    this.recipients = sorted.join("\n");
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        this.recipientList = angular.copy(this.recipientListTemplate);
        this.submitted = false;

        var actionString = (this.settingsId) ? "changed" : "created";
        var dlg = this.dialogs.notify("Success", "The recipient list has been "+actionString+" successfully");
        dlg.result.then(() => {
          that.$state.go("mail-recipient-list");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      var lines = this.recipients.split(/\n/);
      this.recipientList.recipients = [];
      for (let i=0; i < lines.length; i++) {
        // only push this line if it contains a non whitespace character.
        if (/\S/.test(lines[i])) {
          this.recipientList.recipients.push(lines[i].trim());
        }
      }

      if (this.recipientListId) {  // Save changes on the current recipient list
        this.RecipientListService.update({id: this.recipientListId}, this.recipientList, onSuccess, onError);
      } else { // Create new recipient list
        this.RecipientListService.save(this.recipientList, onSuccess, onError);
      }
    }
  }
}

export default angular.module('conduuApp.mailRecipientEdit', [uiRouter])
  .config(routes)
  .component('mailRecipientEdit', {
    template: require('./mail-recipient-edit.html'),
    controller: MailRecipientEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/messaging/mail/recipient/edit/mail-recipient-edit.component.js